import './App.css';
import './css/pageStyle.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Route, Routes } from 'react-router-dom';
import { AuthRoute } from './auth/AuthRoute';
import { HttpRoute } from './api-services/HttpService'; 
import LoginRedirect from './auth/LoginRedirect';
import LoginCallback from './auth/LoginCallback';
import MainLanding from './components/main-components/MainLanding.tsx';
import RecentLinksRoute from './route/RecentLinksRoute.tsx';
import RebateSummaryPage from './components/main-components/RebateSummaryPage';
import CompanyPayoutViewPage from './components/main-components/CompanyPayoutViewPage';
import CompanyProfilePage from './components/main-components/CompanyProfilePage';
import CompanyDetailsPage from './components/main-components/CompanyDetailsPage';
import AddNewCompanyProfilePage from './components/main-components/AddNewCompanyProfilePage';
import UserInventoryPage from './components/main-components/UserInventoryPage';
import UserEntitlementPage from './components/main-components/UserEntitlementPage';
import TransactionDetailsPage from './components/main-components/TransactionDetailsPage';
import TableauDashboardEmbed from './components/main-components/TableauDashboardEmbed';
import UnderConstructionPage from './components/main-components/UnderConstructionPage';
import ErrorPage from './components/main-components/ErrorPage';
// import MaintenancePage from './components/main-components/MaintenancePage'
import AdminErrorPage from './components/main-components/AdminErrorPage'; 
import AdhocPaymentPage from './components/main-components/AdhocPaymentPage'; 
import SubCompanySearchPage from './components/main-components/SubCompanySearchPage';
import ConsortiumSearchPage from './components/main-components/ConsortiumSearchPage'; 
import AdminDataTechErrorPage from './components/main-components/AdminDataTechErrorPage';
// import PayoutSchedulePage from './components/main-components/PayoutSchedulePage';
import SearchClientContractPage from './components/main-components/SearchClientContractPage';
import SubscribeToResourcePage from './components/main-components/SubscribeToResourcePage'; 
import TableauDashboardContainer from './components/sub-components/TableauDashboardContainer.tsx';
import MyDashboard from './components/main-components/MyDashboard.tsx';
import ConsortiumManagementPage from './components/main-components/ConsortiumManagementPage.jsx'; 
import AddNewConsortiumIdPage from './components/main-components/AddNewConsortiumIdPage.jsx'; 
import CompanyBonusViewPage from './components/main-components/CompanyBonusViewPage.jsx'; 
// import ReleaseNotesPage from './components/main-components/ReleaseNotesPage.jsx';

function App() {
  return (
    <AuthRoute>
      <HttpRoute>
      <RecentLinksRoute>
          <Routes>
            <Route path='/' element={<LoginRedirect/>}/>
            <Route path='/callback' element={<LoginCallback/>}/>
            <Route exact path='/MainLanding' element={<MainLanding/>}/>
            <Route exact path='/RebateSummaryPage' element={<RebateSummaryPage/>}/>
            <Route exact path='/CompanyPayoutViewPage' element={<CompanyPayoutViewPage/>}/>
            <Route exact path='/CompanyProfilePage' element={<CompanyProfilePage/>}/>
            <Route exact path='/CompanyDetailsPage' element={<CompanyDetailsPage/>}/>
             { process.env.REACT_APP_CLIENT_ID !== 'tcb' ? 
            <Route exact path='/AddNewCompanyProfilePage' element={<AddNewCompanyProfilePage/>}/>:
            <Route exact path='/AddNewCompanyProfilePage' element={<MainLanding/>}/>}
            <Route exact path='/UserInventoryPage' element={<UserInventoryPage/>}/>
            <Route exact path='/UserEntitlementPage' element={<UserEntitlementPage/>}/>
            <Route exact path='/TransactionDetailsPage' element={<TransactionDetailsPage/>}/>
            <Route exact path='/TableauDashboardEmbed' element={<TableauDashboardEmbed/>}/>
            <Route exact path='/RebateSummary' element={<TableauDashboardContainer/>}/>
            
            <Route exact path='/REBATEHOME' element={<TableauDashboardContainer/>}/>
            <Route exact path='/RebateStatement' element={<TableauDashboardContainer/>}/>
            <Route exact path='/DetailedRebateStatement' element={<TableauDashboardContainer/>}/>
            <Route exact path='/RebatePerformance' element={<TableauDashboardContainer/>}/>
            <Route exact path='/INTERNALRebateSummary' element={<TableauDashboardContainer/>}/>
            <Route exact path='/INTERNALRebatePerformance' element={<TableauDashboardContainer/>}/>
            <Route exact path='/PORTFOLIOHOME' element={<TableauDashboardContainer/>}/>
            <Route exact path='/ExecutiveSummary' element={<TableauDashboardContainer/>}/>
            <Route exact path='/VolumePerBusinessDay' element={<TableauDashboardContainer/>}/>
            <Route exact path='/TrendedPurchaseVolume' element={<TableauDashboardContainer/>}/>
            <Route exact path='/ProductGroup' element={<TableauDashboardContainer/>}/>
            <Route exact path='/YoYCompanySpendBreakup' element={<TableauDashboardContainer/>}/>
            <Route exact path='/CompanySpendBreakupByRange' element={<TableauDashboardContainer/>}/>
            <Route exact path='/CompanySpendBreakupByRange2' element={<TableauDashboardContainer/>}/>
            <Route exact path='/SpendSummary' element={<TableauDashboardContainer/>}/>
            <Route exact path='/SpendSummary2' element={<TableauDashboardContainer/>}/>
            <Route exact path='/SpendbyMCC' element={<TableauDashboardContainer/>}/>
            <Route exact path='/SpendVariancebyMCC' element={<TableauDashboardContainer/>}/>
            <Route exact path='/AccountManagerSalesSpecialistSnapshot' element={<TableauDashboardContainer/>}/>
            <Route exact path='/SpendProfile' element={<TableauDashboardContainer/>}/>
            <Route exact path='/YoY-CompanyIncreasersDecreasers' element={<TableauDashboardContainer/>}/>
            <Route exact path='/QoQ-CompanyIncreasersDecreasers' element={<TableauDashboardContainer/>}/>
            <Route exact path='/MoM-CompanyIncreasersDecreasers' element={<TableauDashboardContainer/>}/>
            <Route exact path='/TopCompanies' element={<TableauDashboardContainer/>}/>
            <Route exact path='/INTERNALExecutiveSummary' element={<TableauDashboardContainer/>}/>
            <Route exact path='/INTERNALSpendSummary' element={<TableauDashboardContainer/>}/>
            <Route exact path='/INTERNALSpendProfile' element={<TableauDashboardContainer/>}/>

            <Route exact path='/SUPPLIERHOME' element={<TableauDashboardContainer/>}/>
            <Route exact path='/SupplierDetails' element={<TableauDashboardContainer/>}/>
            <Route exact path='/SupplierSearch' element={<TableauDashboardContainer/>}/>
            <Route exact path='/NewSuppliersCompany' element={<TableauDashboardContainer/>}/>
            <Route exact path='/NewSuppliersBank' element={<TableauDashboardContainer/>}/>
            <Route exact path='/Top50Suppliers' element={<TableauDashboardContainer/>}/>
            <Route exact path='/PPS' element={<TableauDashboardContainer/>}/>
            <Route exact path='/Top50SuppliersbySpend' element={<TableauDashboardContainer/>}/>
            <Route exact path='/SpendbyRegion' element={<TableauDashboardContainer/>}/>
            <Route exact path='/CompanyDetailsbyState' element={<TableauDashboardContainer/>}/>

            <Route exact path='/MyDashboard' element={<MyDashboard/>}/>
            <Route exact path='/UnderConstructionPage' element={<UnderConstructionPage/>}/>
            <Route exact path='/ErrorPage' element={<ErrorPage/>}/>
            <Route exact path='/AdminErrorPage' element={<AdminErrorPage/>}/>
            <Route exact path='/AdhocPaymentPage' element={<AdhocPaymentPage/>}/>
            <Route exact path='/SubCompanySearchPage' element={<SubCompanySearchPage/>}/>
            <Route exact path='/ConsortiumSearchPage' element={<ConsortiumSearchPage/>}/>
            <Route exact path='/AdminDataTechErrorPage' element={<AdminDataTechErrorPage/>}/>
            <Route exact path='/ConsortiumManagementPage' element={<ConsortiumManagementPage/>}/>
            <Route exact path='/ReleaseNotes' element={<UnderConstructionPage/>}/>
           {/* { process.env.REACT_APP_REBATE_PAYOUT_SCHEDULER == '1' ?
            <Route exact path='/PayoutSchedulePage' element={<PayoutSchedulePage/>}/>
            : <Route exact path='/PayoutSchedulePage' element={<SubscribeToResourcePage/>}/>} */}
            { process.env.REACT_APP_UPLOAD_CLIENT_CONTRACTS == '1' ?
            <Route exact path='/SearchClientContractPage' element={<SearchClientContractPage/>}/>
            : <Route exact path='/SearchClientContractPage' element={<SubscribeToResourcePage/>}/>}
            <Route exact path='/AddConsortiumIdPage' element={<AddNewConsortiumIdPage/>} />
            {/* Bonuses page */}
            <Route exact path='/CompanyBonusViewPage' element={<CompanyBonusViewPage/>}/>
          </Routes>
           </RecentLinksRoute>
      </HttpRoute>
    </AuthRoute>
  );
}

export default App;
